import React, { createContext, useContext, useState } from 'react';
import DemoBookingModal from '../components/DemoBookingModal';

const DemoModalContext = createContext();

export const useDemoModal = () => {
  const context = useContext(DemoModalContext);
  if (!context) {
    throw new Error('useDemoModal must be used within a DemoModalProvider');
  }
  return context;
};

export const DemoModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openDemoModal = () => setIsOpen(true);
  const closeDemoModal = () => setIsOpen(false);

  return (
    <DemoModalContext.Provider value={{ isOpen, openDemoModal, closeDemoModal }}>
      {children}
      <DemoBookingModal isOpen={isOpen} onClose={closeDemoModal} />
    </DemoModalContext.Provider>
  );
};
